import { FC } from 'react';
import CustomLoading from 'modules/_shared/components/CustomLoading';
import { useCompleteOperationModal } from './context/CompleteOperationModalContext';
import CompleteOperationModalHeader from './components/CompleteOperationModalHeader';
import CompleteOperationModalBody from './components/CompleteOperationModalBody';
import CompleteOperationModalFooter from './components/CompleteOperationModalFooter';

const CompleteOperationModal: FC = () => {
  const { data } = useCompleteOperationModal();

  return (
    <>
      <CompleteOperationModalHeader />
      <CompleteOperationModalBody />
      <CompleteOperationModalFooter />
      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default CompleteOperationModal;
